import DollarReceiptSvg from '@assets/images/svg/dollar-receipt.svg';
import React from 'react';
import { View } from 'react-native';

export interface DollarReceiptIconProps {
  size?: number;
  color?: string;
}

/** Receipt with $ — Figma “Unit Price” section header icon. */
export function DollarReceiptIcon({
  size = 24,
  color = '#333333',
}: Readonly<DollarReceiptIconProps>) {
  return (
    <View
      style={{
        width: size,
        height: size,
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <DollarReceiptSvg width={size} height={size} color={color} />
    </View>
  );
}

export default DollarReceiptIcon;
